export const COLORS = {
    bg: 0x0a0f0a,
    text: "#33ff66",
    dim: "#1faa44",
    bright: "#7fff9f",
    amber: "#ffb000",
} as const;

export const FONT = "VT323, Courier New, monospace";
export const BANNER_FONT = '"Courier New", Courier, monospace';
export const FONT_SIZE = 44;
export const FONT_SIZE_BANNER = 22;
export const LINE_H = 52;
export const PADDING = 72;
export const STATUS_LINE_H = 40;
export const STATUS_FONT_SIZE = 36;
export const STATUS_GAP = 6;
export const STATUS_ITEM_GAP = 20;
export const INPUT_GRADIENT_HEIGHT = 96;
export const INPUT_PIXEL = 8;
export const INPUT_GRADIENT_STEPS = 8;
export const PROFILE_TEXTURE_KEY = "profile-pic";
export const PROFILE_TEXTURE_FILTERED_KEY = "profile-pic-green";
export const PROFILE_TEXTURE_FILTERED_ENHANCED_KEY = "profile-pic-green-full";
export const SCANLINE_STEP_PX = 2;
export const SCANLINE_DELAY_MS = 22;
export const ENHANCE_SCANLINE_DELAY_MS = SCANLINE_DELAY_MS * 4;
export const GAME_WIDTH = 1440;
export const GAME_HEIGHT = 900;
export const FOOTER_DEPTH = 100_001;
export const REBOOT_COUNTDOWN = "Rebooting in {n} ...";
